import React from 'react'
import Equalizer from 'react-equalizer'
import { ProductWithActiveColour } from '../../types'
import { Product } from './Product'

interface Props {
  products: ProductWithActiveColour[]
}

export const ProductList: React.FC<Props> = ({ products }) => (
  <Equalizer>
    {products.map(product => (
      <Product key={product.activeColour.uuid} product={product} />
    ))}
  </Equalizer>
)
